import { useIntl } from '@grandvisionhq/state';

const useAppointmentDurationLabel = (type)=>{
    const { getLabel  } = useIntl();
    const { amount , unit  } = type && type.duration ? type.duration : {
        amount: 0,
        unit: 'MINUTES'
    };
    return amount > 0 ? `${amount} ${getLabel(`appointments.shortTimeUnits.${unit.toLowerCase()}`)}` : undefined;
};

export { useAppointmentDurationLabel };
//# sourceMappingURL=use-appointment-duration-label.js.map
